import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-uncommentedvideopercentage-card',
  templateUrl: './helpbutton-reports-uncommentedvideopercentage-card.component.html',
  styleUrls: ['./helpbutton-reports-uncommentedvideopercentage-card.component.scss']
})
export class HelpbuttonReportsUncommentedvideopercentageCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

  public getRoundedValue() {
    if (this.value) {
      return this.value.toFixed(2);
    } else {
      return 0;
    }
  }
}
